import prizesList from "./prizesList";
import corporateValuesList from "./corporateValuesList";
import teamMembers from "./teamMembers";
import services from "./services";
import sponsors from "../../../config/sponsors";

export { prizesList, corporateValuesList, teamMembers, services, sponsors };



// WEBPACK FOOTER //
// ./src/views/AboutUsPage/assets/index.js